import { Service } from '@src/slide/infrastructure/module/independent/windows-message-protocol';
import { ISlideInitialData, SlideInitialDataType } from '../interfaces/slide-initial-data-service.interface';
import { SlideDataServices } from '../slide-data-services.core';
import set from 'lodash/set';
import { ISlideAppService } from '../interfaces/slide-app-service.interface';
import { onServicesReady } from '../../utils/service-awaiter';

const { SlideAppService, ContentStatusManager } = SlideDataServices;

/**
 * 主窗口向副窗口提供数据服务
 */
export class MainWindowDataProviderService extends Service {
    public static namespace = 'MainWindowDataProviderService';

    public async getClientVars(): Promise<Record<string, any>> {
        await this.waitForSlideAppReady();
        const clientVars = await SlideDataServices.ClientVarsService.promise();
        const presentationStoreService = await SlideDataServices.SDKDataServices.PresentationStoreService.promise();
        const presentationString = presentationStoreService.getSerializedPresentationData();
        const cloneClientVars = clientVars.getCloneClientVars();
        set(cloneClientVars, 'collab_client_vars.initialAttributedText.text', presentationString);
        return cloneClientVars;
    }

    public async getSlideInitialData(): Promise<ISlideInitialData> {
        await this.waitForSlideAppReady();
        const presentationStoreService = await SlideDataServices.SDKDataServices.PresentationStoreService.promise();
        return {
            type: SlideInitialDataType.PresentationData,
            data: presentationStoreService.getPresentation().getCloneData(),
        };
    }

    private async waitForSlideAppReady(): Promise<ISlideAppService> {
        return new Promise((resolve) => {
            onServicesReady([SlideAppService, ContentStatusManager], (app, contentStatus) => {
                contentStatus.onDocumentReady(() => resolve(app));
            });
        });
    }
}
